export default __webpack_public_path__ + "static/media/confirm.4f97874d.svg";